import { createTimeout } from '.'

/**
 * Creates a promise by the given amount
 *
 * @param time in milliseconds
 * @throws never
 */
export const delay = async (time: number): Promise<void> => new Promise((resolve) => createTimeout(resolve, time))
